module.exports = __webpack_public_path__ + "img/logoWhite.4aef0778.png";